import classNames from 'clsx';
import React, { type FC, memo } from 'react';
import { getDuplicatePreviewUrl } from 'reactApp/modules/duplicates/duplicates.helpers';
import type { IDuplicatesPreviewItem } from 'reactApp/modules/duplicates/duplicates.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { Link } from 'reactApp/ui/Link/Link';

import styles from './DuplicatesPreviewVariant3.css';

interface IProps {
    rootClassName: string;
    imgClassName: string;
    items: IDuplicatesPreviewItem[];
    label: React.ReactNode;
    onClick: VoidFunction;
}

export const DuplicatesPreviewVariant3: FC<IProps> = memo(function DuplicatesPreviewVariant3(props: IProps) {
    const { rootClassName, imgClassName, label, items, onClick } = props;

    return (
        <Link id="duplicates" storage={EStorageType.duplicates} className={rootClassName} handleClick={onClick}>
            {label}
            <img key={1} src={getDuplicatePreviewUrl(items[0])} className={imgClassName} />
            <img key={2} src={getDuplicatePreviewUrl(items[1])} className={classNames(imgClassName, styles.img2)} />
            <img key={3} src={getDuplicatePreviewUrl(items[2])} className={classNames(imgClassName, styles.img3)} />
        </Link>
    );
});
